import React from 'react';
import { TailSpin } from 'react-loader-spinner';
import { isNumber } from 'lodash';

/* eslint-disable-next-line */
export interface LoadingSpinnerProps {
  size?: number | 'small' | 'large' | undefined;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'large',
}) => {
  return (
    <TailSpin
      height={isNumber(size) ? size : size === 'small' ? 25 : 45}
      width={isNumber(size) ? size : size === 'small' ? 25 : 45}
      wrapperStyle={{
        padding: '8px',
      }}
    />
  );
};
